import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

async function request(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, options);
  if (!res.ok) {
    const data = await res.json().catch(() => null);
    const err = new Error(messageFromErrorBody(data, `Request failed: ${res.status}`));
    err.status = res.status;
    throw err;
  }
  const text = await res.text();
  return text ? JSON.parse(text) : null;
}

/** Host: creates (or returns existing) room for a meeting. */
export function startMeetingRoom(meetingId) {
  return request(`/api/meeting-rooms/${meetingId}/start`, {
    method: 'POST',
    headers: jsonHeaders(),
  });
}

/** Any participant: load room info by token. */
export function getRoomByToken(token) {
  return request(`/api/meeting-rooms/by-token/${token}`, {
    headers: jsonHeaders(),
  });
}

/** Any participant: get the active room for a meeting (to join as non-host). */
export function getActiveMeetingRoom(meetingId) {
  return request(`/api/meeting-rooms/${meetingId}/active`, {
    headers: jsonHeaders(),
  });
}

/** Host: end the room. */
export function endMeetingRoom(token) {
  return request(`/api/meeting-rooms/by-token/${token}/end`, {
    method: 'POST',
    headers: jsonHeaders(),
  });
}

/**
 * Host: upload the finished recording — stored on the server and filed into the
 * company archive automatically. Returns { fileUrl, archivedItemId }.
 */
export async function uploadMeetingRecording(token, blob, fileName) {
  const form = new FormData();
  form.append('file', blob, fileName || 'meeting-recording.webm');
  const res = await fetch(`${API_BASE}/api/meeting-rooms/by-token/${token}/recording`, {
    method: 'POST',
    headers: authHeaders(), // no Content-Type — browser sets multipart boundary
    body: form,
  });
  if (!res.ok) {
    const data = await res.json().catch(() => null);
    const err = new Error(messageFromErrorBody(data, `Upload failed: ${res.status}`));
    err.status = res.status;
    throw err;
  }
  return res.json();
}

/**
 * Upload a chat attachment (image or file).
 * Returns { url, fileName, fileSize, type }
 */
export async function uploadChatFile(file) {
  const form = new FormData();
  form.append('file', file);
  const res = await fetch(`${API_BASE}/api/meeting-rooms/upload-chat-file`, {
    method: 'POST',
    headers: authHeaders(),   // no Content-Type — browser sets multipart boundary
    body: form,
  });
  if (!res.ok) {
    const data = await res.json().catch(() => null);
    const err = new Error(messageFromErrorBody(data, `Upload failed: ${res.status}`));
    err.status = res.status;
    throw err;
  }
  return res.json();
}
